import { UserType } from '@prisma/client';
import { useAuth } from '../contexts/AuthContext';
import useNewClientPause from './useNewClientPause';

const WAITLISTED_TYPES: string[] = [UserType.CUSTOMER];

/**
 * True when the current user signed up during the new-client pause and is a
 * direct client (BUYER/SELLER). Mirrors the backend guard
 * (apps/homepoint-api/src/hooks/before/block-waitlisted.ts) — the backend is
 * the enforcement; this only drives UX.
 */
const useIsWaitlisted = (): boolean => {
  const { currentUser } = useAuth();
  const { pauseActive, pauseStart } = useNewClientPause();

  if (!pauseActive || !pauseStart || !currentUser?.createdAt) return false;
  if (!WAITLISTED_TYPES.includes(currentUser.type)) return false;

  return new Date(currentUser.createdAt) >= new Date(pauseStart);
};

export default useIsWaitlisted;
